import {NgModule} from '@angular/core';

import {Nl2BrPipe} from './nl2br.pipe';
import {BrowserModule} from '@angular/platform-browser';

@NgModule({
    imports: [
        BrowserModule
    ],
    declarations: [
        Nl2BrPipe
    ],
    exports: [Nl2BrPipe]
})
export class Nl2BrPipeModule {
}



// WEBPACK FOOTER //
// /app/src/app/pipes/nl2br-pipe/nl2br-pipe.module.ts